<template>
    <b-container fluid>
       <b-row>
          <b-col sm="12">
               <card>
                  <template v-slot:headerTitle>
                        <h4 class="card-title">Add Attribute</h4>
                  </template>
                  
                  <template v-slot:body>                     

                     <!---- Add attribute form starts ---->
                     
                     <b-form @submit.prevent="addAttribute">
                        <b-row>
                           <b-col md="6" class="form-group">
                              <label class="control-label">Name <span class="required">*</span></label>
                              <b-form-input v-model="attribute.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback"> 
                                 <p class="mb-0">{{val}}</p>
                              </div> 
                           </b-col>

                           <b-col md="6" class="form-group">   
                              <label class="control-label">Type <span class="required">*</span></label> 
                              <b-form-select  v-model="attribute.type"  v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <template #first>
                                   <b-form-select-option :value="null" disabled>-- Select Type --</b-form-select-option>
                                 </template>
                                 <b-form-select-option v-for="type in types" :key="type.id" :value="type.id">{{type.name}}</b-form-select-option>
                              </b-form-select>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback"> 
                                 <p class="mb-0">{{val}}</p>
                              </div> 
                           </b-col>
                           
                           <b-col md="6" v-if="attribute.type==1 || attribute.type==2 || attribute.type==5">
                              <div class="input-dynamic">
                                 <label class="control-label">Values <span class="required">*</span></label>
                                 <b-row v-for="(input, index) in inputs" :key="index">    
                                    <b-col md="12" class="form-group">
                                       <b-form-input class="w-90" v-model="input.value" required></b-form-input>
                                       <span>
                                          <i class="fas fa-minus-circle text-danger" @click="remove(index)" v-show="index || ( !index && inputs.length > 1)"></i>
                                          <i class="fas fa-plus-circle text-green" @click="add()" v-show="index == inputs.length-1"></i>
                                       </span>
                                    </b-col>
                                 </b-row>
                              </div>
                           </b-col>                      

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="mr-3" variant="primary">Add</b-button>
                              <b-button class="" variant="light" @click="clearForm()">Reset</b-button>                          
                           </b-col>
                        </b-row>

                     </b-form>
                     
                     <!----Add attribute form ends ----->                     

                  </template>
               </card>
          </b-col>
       </b-row>
    </b-container>
</template>
<script>
export default {
   name:'AddAttribute',
   data() {
      return {
         attribute: {
            id: null,
            name: "",
            type: null,            
         },  
         types: {},
         inputs: [
            {value: ''}
         ],
         attribute_values: [],         
         token: '',
         errors: {}
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchAttributeTypes();
   },

   methods: {    

      getToken() {
         if(localStorage.token) {
            this.token = localStorage.token;
         } else {
            this.$vToastify.error('Session expired, please login again');
            this.$router.push({name: 'auth.login'})
         }
      },
      fetchAttributeTypes() {
         this.getToken();
         this.$axios
            .get("/api/admin/attributes/types",{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data;
               this.types = responseData.data;
               
            })
            .catch(err => console.log(err));
      },

      add() {
         this.inputs.push({ value: '' });
      },

      remove(index) {
         this.inputs.splice(index, 1);
      }, 

      addAttribute(){
         this.getToken();   
         this.inputs.forEach(obj => {
            if(obj.value != '') {
               this.attribute_values.push(obj.value);
            }            
         })           
         let formData = new FormData();  
         formData.append('name', this.attribute.name);
         formData.append('type', this.attribute.type);         
         formData.append('attribute_values', JSON.stringify(this.attribute_values));       
         
         const config = {
              headers: {
                  
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         let url;
         url = '/api/admin/attributes/add';
         
          this.$axios
          .post(url, formData, config)
          .then(response => {
              if(response.data.status) {
                  this.$vToastify.success(response.data.message);
              } else {
                  this.$vToastify.error(response.data.message);
              }
              this.clearForm();              
          })
          .catch(error => {
              
               if(error.response){
                  if(error.response.data.message){
                     console.log(error.response.data);
                     this.errors = error.response.data.message;
                     this.$vToastify.error(error.response.message);
                  } else {
                     this.$vToastify.error("Error!");
                  }                  
               } else {
                  this.$vToastify.error("Error!");
               }
               
          }); 
               
       },

      clearForm() {
         this.attribute.name = '';
         this.attribute.type = null;
         this.attribute_values = [];   
         this.inputs = [{value: ''}];      
         this.errors = {};
      },
      
   }   
}
</script>